// Generated by genversion.
export const version = '2.3.1';
//# sourceMappingURL=version.js.map